import {connect} from 'react-redux';
import {State} from '../../../types/mx/reducers';
import * as ModalActions from '../../../../wizard/actions/ModalActions';
import {AnyAction, Dispatch} from 'redux';
import * as AttachmentsActions from '../actions/AttachmentsActions';
import {DocumentTypes, FileState, LoanApplicationAttachmentsState} from '../types/types';
import {DocsState} from '../types/reducers';
import {findDocumentsByGroup} from '../utils/LoanAttachmentsUtils';
import AttachmentDeleteModalView from '../components/views/AttachmentDeleteModalView';
import {FILES_SECTION} from '../constants/LabelConstants';
import {AttachmentsDeleteDispatchProps, AttachmentsDeleteStateProps} from '../types/containers';

const mapStateToProps = (state: State, ownProps): AttachmentsDeleteStateProps => {
    const data = ownProps.data || null;
    const file: FileState = !!data ? data.file : null;
    const viewType: string = !!data ? data.viewType : null;
    const isDetailAttachment: boolean = viewType === FILES_SECTION.SIDEBAR_FORM_TYPE;
    const isFromListAttachment: boolean = viewType === FILES_SECTION.LIST_ATTACHMENT_FORM_TYPE;
    const documentType: DocumentTypes = !!data ? data.documentType : null;
    const documentsVersionId: string = !!data ? data.documentsVersionId : null;
    const docs: DocsState = state.commonLoanApplication.docs;
    const filesQueue: FileState[] = isDetailAttachment ?
        docs.attachmentDetail.files.filter(item => !item.isUploaded)
        : isFromListAttachment ? [] : docs.attachmentsForm.files.filter(item => !item.isUploaded);

    const groupedDocumentType: LoanApplicationAttachmentsState =
        findDocumentsByGroup(docs, documentType);

    const filesLength: number = (isDetailAttachment ? docs.attachmentDetail.files.length
        : isFromListAttachment ? groupedDocumentType.documentGroups.length : docs.attachmentsForm.files.length);
    const filesUploaded: number = filesLength - filesQueue.length;

    const versions: number = groupedDocumentType.versions.length;
    return {
        file,
        documentType,
        filesQueue,
        versions,
        filesUploaded,
        documentsVersionId
    };
};

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>): AttachmentsDeleteDispatchProps => {
    return {
        onPressDeleteConfirm: (file: FileState, documentType: DocumentTypes, filesQueue: FileState[],
        documentsVersionId: string, filesUploadedNumber: number) => () => {
            if (filesQueue.length > 0) {
                dispatch(AttachmentsActions.UPLOAD_AND_DELETE_LOAN_ATTACHMENTS_ACTION_REQUEST
                    .action(file, filesQueue, documentType, documentsVersionId));
            } else {
                dispatch(AttachmentsActions.DELETE_LOAN_ATTACHMENT_ACTION_REQUEST.action(
                    file, documentType
                ));
                if (filesUploadedNumber === 1) {
                    dispatch(AttachmentsActions.CLOSE_SIDEBAR_ALL_ATTACHMENTS.action());
                    dispatch(AttachmentsActions.CLOSE_SIDEBAR_DETAIL_ATTACHMENTS.action());
                    dispatch(ModalActions.CLOSE_MODAL_ACTION.action());
                }
            }
            dispatch(ModalActions.CLOSE_MODAL_ACTION.action(false));
        },
        onPressClose: () => {
            dispatch(ModalActions.CLOSE_MODAL_ACTION.action(false));
        }
    };
};

const mergeProps = (stateProps, dispatchProps) => {
    const file: FileState = stateProps.file;
    const documentType: DocumentTypes = stateProps.documentType;
    const filesQueue: FileState[] = stateProps.filesQueue;
    const documentsVersionId: string = stateProps.documentsVersionId;
    const filesUploadedNumber: number = stateProps.filesUploaded;
    return {
        ...stateProps,
        ...dispatchProps,
        onPressDeleteConfirm: dispatchProps.onPressDeleteConfirm(file, documentType, filesQueue, documentsVersionId,
            filesUploadedNumber)
    };
};

const AttachmentDeleteContainer = connect(
    mapStateToProps, mapDispatchToProps, mergeProps
)(AttachmentDeleteModalView);

export default AttachmentDeleteContainer;